import numeral from 'numeral';

function formatPrice(number) {
  return numeral(number).format('0,0.[0]a');
}

export default function getFormattedPrice({ minPrice, maxPrice }) {
  if (minPrice && maxPrice) {
    return `$${formatPrice(minPrice)} - $${formatPrice(maxPrice)}`;
  }
  if (minPrice && !maxPrice) {
    return `Above $${formatPrice(minPrice)}`;
  }
  if (!minPrice && maxPrice) {
    return `Below $${formatPrice(maxPrice)}`;
  }
  return '';
}
